import { FilterList as FilterListIcon } from '@mui/icons-material';

const FilterList = (): JSX.Element => <FilterListIcon fontSize="inherit" />;

export default FilterList;
